// components/ConfirmModal.js
import React from 'react';
import Modal from 'react-modal';
import styles from './ConfirmModal.module.css';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  type = "default", // 'default', 'danger', 'warning'
  isProcessing = false
}) => {
  
  const getConfirmButtonClass = () => {
    const baseClass = styles.confirmButton;
    switch(type) {
      case 'danger':
        return `${baseClass} ${styles.confirmButtonDanger}`;
      case 'warning':
        return `${baseClass} ${styles.confirmButtonWarning}`;
      default:
        return `${baseClass} ${styles.confirmButtonDefault}`;
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => !isProcessing && onClose()}
      className={styles.modalContent}
      overlayClassName={styles.modalOverlay}
      style={{
        overlay: { zIndex: 10000000000000 },
        content: { zIndex: 10000000000001 }
      }}
    >
      <h3 className={styles.modalTitle}>{title}</h3>
      <p className={styles.modalMessage}>{message}</p>
      <div className={styles.modalActions}>
        <button 
          className={`${getConfirmButtonClass()} ${isProcessing ? styles.confirmButtonDisabled : ''}`}
          disabled={isProcessing}
          onClick={onConfirm}
        >
          {isProcessing ? 'Processing...' : confirmText}
        </button>
        <button 
          className={styles.cancelButton}
          disabled={isProcessing}
          onClick={onClose}
        >
          {cancelText}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmModal;